import { apiService } from "../apiService";
import urlConfig from "../../config/domain";
import myAppsUrlConfig from "../../config/MyApp/myAppsURLConfig";

export const getAllApps = (callback, userId) => {
  console.log("getAllApps", userId);
  apiService(
    {
      url: myAppsUrlConfig.myApps + userId,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
    },
    callback
  );
};

export const deleteApp = (callback, app) => {
  const url = myAppsUrlConfig.deleteApp + app.accId + app.appNm;
  console.log(url);
  apiService(
    {
      url: myAppsUrlConfig.myApps + app.accId + "?appNm=" + app.appNm,
      method: "DELETE",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      source: sessionStorage.getItem("source") || undefined,
      sourcetoken: sessionStorage.getItem("sourceToken") || undefined,
    },
    callback
  );
};
export const createApp = (callback, userId, body) => {
  apiService(
    {
      url: myAppsUrlConfig.myApps + userId,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const editApp = (callback, userId, body) => {
  apiService(
    {
      url: myAppsUrlConfig.myApps + userId,
      method: "PUT",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const getAnalyticsData = (callback, userId, body) => {
  apiService(
    {
      url:
        myAppsUrlConfig.myApps +
        "edelapi/clientanalytics/" +
        userId +
        `?frmDt=${body.frmDt}&toDt=${body.toDt}&src=${body.api_key}`,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
    },
    callback
  );
};

// Vendor's api functions
export const vendorGetAllApps = (callback, userId) => {
  apiService(
    {
      url: myAppsUrlConfig.mySubscription + userId,
      method: "GET",
      authType: "access_token",
      appidkey: urlConfig.appidkey,
    },
    callback
  );
};

export const vendorCreateApp = (callback, userId, body) => {
  apiService(
    {
      url: myAppsUrlConfig.mySubscription + userId,
      method: "POST",
      authType: "access_token",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};
export const vendorModifyApp = (callback, userId, body, access_token) => {
  apiService(
    {
      url: myAppsUrlConfig.mySubscription + userId,
      method: "PUT",
      authType: "access_token",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};
export const vendorDashboard = (callback, url) => {
  apiService(
    {
      url: `${myAppsUrlConfig.mySubscription}analytics/${url.userId}?frmDt=${url.frmDt}&toDt=${url.toDt}`,
      method: "GET",
      authType: "access_token",
      appidkey: urlConfig.appidkey,
      body: {},
    },
    callback
  );
};
export const downloadReports = (callback, url) => {
  apiService(
    {
      url: `${myAppsUrlConfig.downloadReports}?frmDt=${url.frmDt}&toDt=${url.toDt}&apiKey=${url.apiKey}&rpTyp=${url.rpTyp}`,
      method: "GET",
      authType: "access_token",
      appidkey: urlConfig.appidkey,
      body: {},
    },
    callback
  );
};
